require('./cardPayLaterSuccessStep.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');

// @commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { getCurrencySymbol, formatAmount } = require('utilities/currencyHelper');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

// @utils
const { getLastNChars } = require('utilities/stringHelper');

class CardPayLaterSuccessStep extends React.Component {
    render() {
        const { immCard, immCardPayLater } = this.props;
        const cardNumber = getLastNChars(immCard.get('number'));
        const title = formatText('cardPayLater-successTitle', [ cardNumber ]);
        const goBackButtonLabel = formatText('cardPayLater-backToCard').toUpperCase();
        const goBackButton = {
            label: goBackButtonLabel,
            url: '/myprofile/cards'
        }
        const immStepOne = immCardPayLater.getIn(['steps', 0]);
        const disposedBalance = immCard.get('balanceDrawn');
        const currencySymbol = getCurrencySymbol(disposedBalance);
        const maxImportFormattedAmount = formatAmount(immStepOne.get('import'));
        const maxImport = `${maxImportFormattedAmount} ${currencySymbol}`;

        return (
            <div className="card-pay-later-success col-xs-12 col-md-offset-1 col-md-10 col-lg-offset-2 col-lg-8">
                <WizardSuccess
                    successMessage={title}
                    mainButton={goBackButton}>
                    <section className="row">
                        <div className="col-xs-6 col-md-7">
                            <CommercialAds path="cards" type="cards" immCard={immCard} size="medium" />
                        </div>
                        <div className="col-xs-6 col-md-5">
                            <FormattedText
                                value="cardPayLater-successMessage"
                                injectedStrings={[
                                    maxImport
                                ]}
                            />
                        </div>
                    </section>
                </WizardSuccess>
            </div>
        )
    }
}

CardPayLaterSuccessStep.propTypes = {
    immCard: PropTypes.object.isRequired,
    immCardPayLater: PropTypes.object.isRequired
};

module.exports = CardPayLaterSuccessStep;